import { CREATE_DOCTOR_FAIL, CREATE_DOCTOR_REQUEST, CREATE_DOCTOR_SUCCESS, FETCH_DOCTOR_FAIL, FETCH_DOCTOR_REQUEST, FETCH_DOCTOR_SUCCESS } from "../../ActionType/DoctorType/DoctorType";

  export const createDoctoReducer = (
    state = { loading: true, doctors: [], error: "" },
    action
  ) => {
    switch (action.type) {
      case CREATE_DOCTOR_REQUEST:
        return {
          loading: true,
          doctors:action.payload
        };
      case CREATE_DOCTOR_SUCCESS:
        return {
          loading: false,
          doctors:action.payload,
          error:"",
        };
      case CREATE_DOCTOR_FAIL:
        return {
          loading: false,
          doctors:action.payload,
          error:"",
        };
      default:
        return state;
    }
  };
  

  export const getDoctoReducer = (
    state = { loading: true, doctors: [], error: "" },
    action
  ) => {
    switch (action.type) {
      case FETCH_DOCTOR_REQUEST:
        return {
          loading: true,
          doctors:action.payload
        };
      case FETCH_DOCTOR_SUCCESS:
        return {
          loading: false,
          doctors:action.payload,
          error:"",
        };
      case FETCH_DOCTOR_FAIL:
        return {
          loading: false,
          doctors:action.payload,
          error:"",
        };
      default:
        return state;
    }
  };
  
  